<template>
  <div class="bodybody">
    <link
      href="https://fonts.googleapis.com/css2?family=Turret+Road:wght@500;700&display=swap"
      rel="stylesheet"
    />
    <div class="container">
      <div class="wrapper">
        <div class="flexbox">
          <div class="title">Are You A Strong Hand?</div>
          <img src="../assets/whales.gif" alt="" />
        </div>

        <div class="content" data-aos="fade-up" data-aos-duration="1000">
          <div class="strongHandPercent" v-if="strongHandPercent">
            <span class="title1">
              <i class="fas fa-fist-raised"></i> Strong Hand Requirement
              <i class="fas fa-fist-raised"></i>
            </span>
            <span class="content1">
              {{ strongHandPercent }}% Total Supply ~
              {{ strongHandAmount }} HODL
            </span>
          </div>

          <div class="leaderboard">
            <div class="title">Top 15</div>
            <div
              class="holderslist"
              v-for="(holder, i) in holdersList"
              :key="i"
            >
              <div class="holder">
                <div class="box">
                  <span class="addy">{{ holder.address }}</span>
                </div>
                <div class="box">
                  <span class="balance">{{ holder.balance }}</span>
                </div>
                <div class="div" v-if="i == 0">
                  <img :src="insertPic(i)" />
                </div>
                <div class="box" v-if="i > 0">
                  <i :class="insertPic(i)" ></i>
                </div>
              </div>
            </div>
          </div>

          <div class="btn-wrapper">
            <button class="btn" @click="showResult">Are you?</button>
          </div>
          <div class="strongHandStatus" v-bind:class="{ active: isActive }">
            <span v-show="nope" class="nope">
              <img src="../assets/weak.gif" class="weak" />
              NOPE! You need to get STRONGER
              <img src="../assets/weak.gif" class="weak" />
            </span>
            <div v-show="yeah" class="yeah">
              <div class="box">
                <img src="../assets/strong.gif" class="strong" />
                Yes, you are in the STRONG HANDS CLUB
                <img src="../assets/strong.gif" class="strong" />
              </div>

              <div class="btn">
                <button @click="turnOn">Turn Game On</button>
                <button @click="turnOff">Turn Game Off</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Web3 from "web3";

export default {
  data() {
    return {
      account: "",
      hodlABI: [
        { inputs: [], stateMutability: "nonpayable", type: "constructor" },
        {
          anonymous: false,
          inputs: [
            {
              indexed: true,
              internalType: "address",
              name: "owner",
              type: "address",
            },
            {
              indexed: true,
              internalType: "address",
              name: "spender",
              type: "address",
            },
            {
              indexed: false,
              internalType: "uint256",
              name: "value",
              type: "uint256",
            },
          ],
          name: "Approval",
          type: "event",
        },
        {
          anonymous: false,
          inputs: [
            {
              indexed: false,
              internalType: "uint256",
              name: "oldCoolDownTime",
              type: "uint256",
            },
            {
              indexed: false,
              internalType: "uint256",
              name: "newCoolDownTime",
              type: "uint256",
            },
          ],
          name: "ChangeCoolDownTime",
          type: "event",
        },
        {
          anonymous: false,
          inputs: [
            {
              indexed: false,
              internalType: "uint256",
              name: "oldPercentile",
              type: "uint256",
            },
            {
              indexed: false,
              internalType: "uint256",
              name: "newPercentile",
              type: "uint256",
            },
          ],
          name: "ChangeStrongHandPercentile",
          type: "event",
        },
        { anonymous: false, inputs: [], name: "EndGame", type: "event" },
        {
          anonymous: false,
          inputs: [
            {
              indexed: true,
              internalType: "address",
              name: "previousOwner",
              type: "address",
            },
            {
              indexed: true,
              internalType: "address",
              name: "newOwner",
              type: "address",
            },
          ],
          name: "OwnershipTransferred",
          type: "event",
        },
        { anonymous: false, inputs: [], name: "StartGame", type: "event" },
        {
          anonymous: false,
          inputs: [
            {
              indexed: true,
              internalType: "address",
              name: "from",
              type: "address",
            },
            {
              indexed: true,
              internalType: "address",
              name: "to",
              type: "address",
            },
            {
              indexed: false,
              internalType: "uint256",
              name: "value",
              type: "uint256",
            },
          ],
          name: "Transfer",
          type: "event",
        },
        {
          inputs: [],
          name: "_burnedSupply",
          outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
          stateMutability: "view",
          type: "function",
        },
        {
          inputs: [],
          name: "_coolDownTime",
          outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
          stateMutability: "view",
          type: "function",
        },
        {
          inputs: [],
          name: "_gameStarted",
          outputs: [{ internalType: "bool", name: "", type: "bool" }],
          stateMutability: "view",
          type: "function",
        },
        {
          inputs: [],
          name: "_lastUpdated",
          outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
          stateMutability: "view",
          type: "function",
        },
        {
          inputs: [],
          name: "_strongHandPercentile",
          outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
          stateMutability: "view",
          type: "function",
        },
        {
          inputs: [
            { internalType: "address", name: "owner", type: "address" },
            { internalType: "address", name: "spender", type: "address" },
          ],
          name: "allowance",
          outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
          stateMutability: "view",
          type: "function",
        },
        {
          inputs: [
            { internalType: "address", name: "spender", type: "address" },
            { internalType: "uint256", name: "amount", type: "uint256" },
          ],
          name: "approve",
          outputs: [{ internalType: "bool", name: "", type: "bool" }],
          stateMutability: "nonpayable",
          type: "function",
        },
        {
          inputs: [
            { internalType: "address", name: "account", type: "address" },
          ],
          name: "balanceOf",
          outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
          stateMutability: "view",
          type: "function",
        },
        {
          inputs: [],
          name: "decimals",
          outputs: [{ internalType: "uint8", name: "", type: "uint8" }],
          stateMutability: "view",
          type: "function",
        },
        {
          inputs: [
            { internalType: "address", name: "spender", type: "address" },
            {
              internalType: "uint256",
              name: "subtractedValue",
              type: "uint256",
            },
          ],
          name: "decreaseAllowance",
          outputs: [{ internalType: "bool", name: "", type: "bool" }],
          stateMutability: "nonpayable",
          type: "function",
        },
        {
          inputs: [],
          name: "endGame",
          outputs: [],
          stateMutability: "nonpayable",
          type: "function",
        },
        {
          inputs: [
            { internalType: "address", name: "spender", type: "address" },
            { internalType: "uint256", name: "addedValue", type: "uint256" },
          ],
          name: "increaseAllowance",
          outputs: [{ internalType: "bool", name: "", type: "bool" }],
          stateMutability: "nonpayable",
          type: "function",
        },
        {
          inputs: [],
          name: "name",
          outputs: [{ internalType: "string", name: "", type: "string" }],
          stateMutability: "view",
          type: "function",
        },
        {
          inputs: [],
          name: "owner",
          outputs: [{ internalType: "address", name: "", type: "address" }],
          stateMutability: "view",
          type: "function",
        },
        {
          inputs: [],
          name: "renounceOwnership",
          outputs: [],
          stateMutability: "nonpayable",
          type: "function",
        },
        {
          inputs: [
            { internalType: "uint256", name: "coolDownTime", type: "uint256" },
          ],
          name: "setCoolDownTime",
          outputs: [],
          stateMutability: "nonpayable",
          type: "function",
        },
        {
          inputs: [
            { internalType: "uint256", name: "percentile", type: "uint256" },
          ],
          name: "setStrongHandPercentile",
          outputs: [],
          stateMutability: "nonpayable",
          type: "function",
        },
        {
          inputs: [],
          name: "startGame",
          outputs: [],
          stateMutability: "nonpayable",
          type: "function",
        },
        {
          inputs: [],
          name: "symbol",
          outputs: [{ internalType: "string", name: "", type: "string" }],
          stateMutability: "view",
          type: "function",
        },
        {
          inputs: [],
          name: "totalSupply",
          outputs: [{ internalType: "uint256", name: "", type: "uint256" }],
          stateMutability: "view",
          type: "function",
        },
        {
          inputs: [
            { internalType: "address", name: "recipient", type: "address" },
            { internalType: "uint256", name: "amount", type: "uint256" },
          ],
          name: "transfer",
          outputs: [{ internalType: "bool", name: "", type: "bool" }],
          stateMutability: "nonpayable",
          type: "function",
        },
        {
          inputs: [
            { internalType: "address", name: "sender", type: "address" },
            { internalType: "address", name: "recipient", type: "address" },
            { internalType: "uint256", name: "amount", type: "uint256" },
          ],
          name: "transferFrom",
          outputs: [{ internalType: "bool", name: "", type: "bool" }],
          stateMutability: "nonpayable",
          type: "function",
        },
        {
          inputs: [
            { internalType: "address", name: "newOwner", type: "address" },
          ],
          name: "transferOwnership",
          outputs: [],
          stateMutability: "nonpayable",
          type: "function",
        },
      ],
      hodlAddy: "0x9B574599822642B04d0fF7e5776dF3A06f4540ba",
      hodlBalance: "",
      fullAccount: "",
      nope: 0,
      yeah: 0,
      strongHandPercent: "",
      strongHandAmount: "",
      holdersList: [],
      imgList: ["mrhodl"],
      isActive: false,
    };
  },
  methods: {
    showResult() {
      this.isActive = !this.isActive;
    },
    async enableWallet() {
      let ethereum = window.ethereum;
      const accounts = await ethereum.request({
        method: "eth_requestAccounts",
      });
      let account =
        (await accounts[0].substring(0, 6)) +
        "..." +
        accounts[0].substring(19, 24);
      this.account = account;
      this.fullAccount = accounts[0];

      //web3
      var web3 = new Web3(Web3.givenProvider);
      const hodlContract = new web3.eth.Contract(this.hodlABI, this.hodlAddy);

      let hodlbalance = await hodlContract.methods
        .balanceOf(accounts[0])
        .call();
      this.hodlBalance = (hodlbalance / 10 ** 18).toFixed(2);

      let strongHandPercent = await hodlContract.methods
        ._strongHandPercentile()
        .call();
      this.strongHandPercent = strongHandPercent;
      this.strongHandAmount = (30000 * strongHandPercent) / 100;

      if (this.hodlBalance <= this.strongHandAmount) {
        this.nope = 1;
      } else {
        this.yeah = 1;
      }

      let data = await fetch(
        "https://api.ethplorer.io/getTopTokenHolders/0x9b574599822642b04d0ff7e5776df3a06f4540ba?apiKey=EK-kEzSP-3CnfyWq-YJAEE&limit=100"
      ).then((res) => res.json());

      data = data.holders.filter(
        (data) =>
          !data.address.includes("0x79a4c4563a29d49abf5f67af2f73bb3d1f0d6fd6")
      );

      for (let i = 0; i < 15; i++) {
        data[i].address =
          data[i].address.substring(0, 4) +
          "..." +
          data[i].address.substring(38, 42);
        data[i].balance = (data[i].balance / 10 ** 18).toFixed(1);
        this.holdersList.push(data[i]);
      }

      data[0].pic = "mrhodl.png";
      data[1].pic = "weak.gif";
    },
    insertPic(i) {
      if (i == 0) {
        return "/img/" + "mrhodl" + ".png";
      } else if (i == 1) {
        return "fas fa-fist-raised yellow";
      } else if (i == 2) {
        return "fas fa-fist-raised silver";
      } else if (i == 3) {
        return "fas fa-fist-raised bronze";
      } 
    },
    insertIcon(i) {
      console.log(i);
    },
    async turnOn() {
      let ethereum = window.ethereum;
      const accounts = await ethereum.request({
        method: "eth_requestAccounts",
      });
      let account =
        (await accounts[0].substring(0, 6)) +
        "..." +
        accounts[0].substring(19, 24);
      this.account = account;
      this.fullAccount = accounts[0];

      //web3
      var web3 = new Web3(Web3.givenProvider);
      const hodlContract = new web3.eth.Contract(this.hodlABI, this.hodlAddy);

      let gameStatus = await hodlContract.methods
        .startGame()
        .send({ from: this.fullAccount });
      console.log(gameStatus);
    },
    async turnOff() {
      let ethereum = window.ethereum;
      const accounts = await ethereum.request({
        method: "eth_requestAccounts",
      });
      let account =
        (await accounts[0].substring(0, 6)) +
        "..." +
        accounts[0].substring(19, 24);
      this.account = account;
      this.fullAccount = accounts[0];

      //web3
      var web3 = new Web3(Web3.givenProvider);
      const hodlContract = new web3.eth.Contract(this.hodlABI, this.hodlAddy);

      let gameStatus = await hodlContract.methods
        .endGame()
        .send({ from: this.fullAccount });
      console.log(gameStatus);
    },
  },
  mounted() {
    this.enableWallet();
  },
};
</script>

<style lang="scss" scoped>
.bodybody {
  position: relative;

  .statusbox {
    position: absolute;
    top: 5%;
    right: 5%;
    background: white;
    padding: 2em;
    font-family: "Turret Road", cursive;
  }
}

.container {
  background: black;
  padding: 4em 0;
  font-family: "Turret Road", cursive;
  display: grid;
  justify-content: center;
}

.wrapper {
  padding: 2em 2em;
  color: white;
  font-family: "Turret Road", cursive;

  .flexbox {
    display: flex;
    align-items: center;
    margin-bottom: 1em;
    gap: 1em;

    img {
      width: 100px;
    }
  }

  .title {
    font-size: 300%;
    color: white;

    &:hover {
      animation-name: strongHand;
      -webkit-animation-name: strongHand;
      -moz-animation-name: strongHand;
      animation-duration: 0.5s;
      -webkit-animation-duration: 0.5s;
      -moz-animation-duration: 0.5s;
      animation-iteration-count: infinite;
    }
  }

  @keyframes strongHand {
    0% {
      transform: rotate(-1deg);
    }
    10% {
      transform: rotate(0deg);
    }
    20% {
      transform: rotate(1deg);
    }
    30% {
      transform: rotate(0deg);
    }
    40% {
      transform: rotate(-1deg);
    }
    5% {
      transform: rotate(0deg);
    }
    60% {
      transform: rotate(1deg);
    }
    70% {
      transform: rotate(0deg);
    }
    80% {
      transform: rotate(-1deg);
    }
    90% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(-1deg);
    }
  }

  .content {
    margin-top: 4em;
    display: grid;
    grid-gap: 2em;

    .strongHandStatus {
      text-align: center;
      font-size: 200%;
      display: none;
      transition: all 0.3s ease-in-out;

      .btn {
        display: flex;
        gap: 1em;
        justify-content: center;
        button {
          padding: 1em;
          font-family: "Turret Road", cursive;
          background: none;
          border: 1px solid white;
          color: white;
          transition: all 0.2s ease-in-out;
          cursor: pointer;
          &:hover {
            background: rgb(150, 150, 150);
          }

          &:focus {
            outline: none;
          }
        }
      }

      .nope {
        align-self: center;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 0.5em;
      }

      .yeah {
        align-self: center;
        display: grid;
        justify-content: center;
        align-items: center;
        gap: 0.5em;

        .box {
          align-items: center;
        }

        .strong {
          width: 200px;
        }
      }
    }

    .active {
      display: grid;
      align-items: center;
    }

    .btn-wrapper {
      text-align: center;

      .btn {
        padding: 1em;
        font-family: "Turret Road", cursive;
        background: none;
        border: 1px solid white;
        color: white;
        transition: all 0.2s ease-in-out;
        cursor: pointer;

        &:hover {
          animation-name: strongHand;
          -webkit-animation-name: strongHand;
          -moz-animation-name: strongHand;
          animation-duration: 0.5s;
          -webkit-animation-duration: 0.5s;
          -moz-animation-duration: 0.5s;
          animation-iteration-count: infinite;
        }

        &:hover {
          background: rgb(150, 150, 150);
        }

        &:focus {
          outline: none;
        }
      }
    }

    .strongHandPercent {
      display: grid;
      justify-content: center;
      align-items: center;
      text-align: center;
      .title1 {
        font-size: 200%;
        color: white;
      }

      .content1 {
        margin-top: 1em;
        font-size: 150%;
      }
    }

    .box {
      padding: 2em 0;
      display: flex;
      gap: 1em;

      .btn-wrapper {
        display: grid;
        justify-items: center;

        .btn {
          padding: 1em;
          background: black;
          color: white;
          border: 1px solid white;
          cursor: pointer;
          font-family: "Turret Road", cursive;
          transition: all 0.3s ease-in-out;
          font-size: 110%;
          letter-spacing: 1px;
          text-decoration: none;

          &:hover {
            background: rgba(255, 255, 255, 0.5);
            color: black;
            font-weight: bold;
          }

          &:focus {
            outline: none;
          }
        }
      }
    }
  }

  .leaderboard {
    margin: auto;
    background: white;
    border-radius: 5px;
    width: 100%;

    .title {
      color: black;
      text-align: center;
      padding: 0.5em;
    }

    .holderslist {
      margin-top: -1.5em;
      .holder {
        color: black;
        display: grid;
        grid-template-columns: repeat(auto-fit,minmax(50px,1fr));
        align-items: center;
        justify-items: center;
        .box {
          .yellow {
            color:  darkgoldenrod;
          }

          .silver {
            color: #6c7a86;
          }

          .bronze {
            color: brown;
          }
        }
      }
    }
  }
}

@media (max-width: 1200px) {
  .wrapper {
    .leaderboard {
      width: 100%;
    }
  }
}

@media (max-width: 800px) {
  .wrapper {
    .content {
      .strongHandStatus {
        font-size: 150%;

        .nope {
          .weak {
            width: 150px;
          }
        }

        .yeah {
          .strong {
            width: 150px;
          }
        }
      }
    }
  }
}

@media (max-width: 650px) {
  .wrapper {
    .flexbox {
      .title {
        font-size: 200%;
      }

      img {
        width: 50px;
      }
    }
    .content {
      .gridbox {
        grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
      }
    }

    .content {
      .strongHandStatus {
        font-size: 120%;

        .nope {
          .weak {
            width: 120px;
          }
        }

        .yeah {
          .strong {
            width: 120px;
          }
        }
      }
    }
  }
}

@media (max-width: 450px) {
  .wrapper {
    .flexbox {
      .title {
        font-size: 150%;
      }
      img {
        width: 50px;
      }
    }

    .content {
      .strongHandPercent {
        .title1 {
          font-size: 150%;
        }
        .content1 {
          font-size: 100%;
        }
      }
      .strongHandStatus {
        font-size: 90%;

        .nope {
          .weak {
            width: 85px;
          }
        }

        .yeah {
          .strong {
            width: 85px;
          }
        }
      }
    }
  }
}
</style>
